import React, { useContext, useMemo } from 'react';

import Icone from 'Component/Icone';

import { AlertaContexto } from '.';

export interface Props {
    titulo?: string;
    conteudo: string | React.ReactElement | React.ReactElement[];
    tema?: 'success'
        | 'warning'
        | 'danger'
        | 'info'
        | 'primary'
        | 'secondary'
        | 'dark'
        | 'darkless'
        | 'white';
}

const Alerta = ({ titulo, conteudo, tema = 'white' }: Props): React.ReactElement =>
{
    const { setAlerta } = useContext(AlertaContexto);

    const icone = useMemo(() => {
        if (tema == 'danger') {
            return <Icone nome="exclamation-octagon-fill" className="me-3" />;
        } else if (tema == 'warning') {
            return <Icone nome="exclamation-diamond-fill" className="me-3" />;
        } else if (tema == 'info') {
            return <Icone nome="info-circle-fill" className="me-3" />;
        } else if (tema == 'success') {
            return <Icone nome="check-circle-fill" className="me-3" />;
        } else {
            return '';
        }
    }, [ tema ]);

    return (
        <React.Fragment>
            <div className="modal show animate__animated animate__fadeIn animate__faster d-block">
                <div className="modal-dialog modal-dialog-centered">
                    <div className={[
                        'modal-content border-0',
                        tema != 'white' && 'text-light',
                    ].className()}>
                        { titulo && (
                            <div className={ `modal-header bg-${tema} border-opacity-10` }>
                                <h5 className="modal-title">
                                    { icone }
                                    { titulo }
                                </h5>
                            </div>
                        ) }
                        <div className={ `modal-body bg-${tema} border-opacity-10` }>
                            { conteudo }
                        </div>
                        <div className={ `modal-footer bg-${tema} border-opacity-10` }>
                            <button
                                className="btn btn-light"
                                onClick={ () => setAlerta(null) }
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show animate__animated animate__fadeIn animate__faster"></div>
        </React.Fragment>
    )
}

export default Alerta;
